import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/global/CategoryPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/global/FloatMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/global/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/global/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/global/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/global/Load.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/home/crazysal/uat-a/cs-mobile-next/app/components/global/ReduxProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/crazysal/uat-a/cs-mobile-next/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/crazysal/uat-a/cs-mobile-next/styles/reset.scss");
